import React, { Component, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

// Import the CSS
import '../../scss/components/_loader.scss';

export default class Loader extends Component {
	render () {

		let spinner;
		let classes = [ 'loader' ];

		// wholePage property is used to push the loader farther down the page
		if (this.props.overlay) { classes.push('overlay'); }

		if (this.props.visible) {
			spinner = (
				<div className={ classes.join(' ') } key='loader'>
					<div>Loading...</div>
					<img className='hammer' src='/assets/img/hammer.svg' />
				</div>
			);
		}

		return (
			<ReactCSSTransitionGroup
				component={ FirstChild }
				transitionName="loader"
				transitionEnterTimeout={300}
				transitionLeaveTimeout={300}>
				{ spinner }
			</ReactCSSTransitionGroup>
		);
	}
}

Loader.propTypes = {
	overlay: PropTypes.bool,
	visible: PropTypes.bool,
};

Loader.defaultProps = {
	overlay: false,
	visible: true
};


/**
 * This component is passed in to the ReactCSSTransitionGroup so it does not
 * render the content within a <span> tag.
 */
class FirstChild extends Component {
	render () {

		let children = React.Children.toArray(this.props.children);

		return children[0] || null;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/components/Loader.js